const _DESKTOP_BREAKPOINT = 992;

export const isLandscape = () => window.innerWidth > window.innerHeight;
export const isMobile = () => window.innerWidth < _DESKTOP_BREAKPOINT;
export const isMobileLandscape = () => isMobile() && isLandscape();
